import React from 'react';

// Period-over-period delta pill: colored arrow + signed percent. Shared by the
// Google Ads and GA4 KPI cards (was copied byte-for-byte into both).
//
// `direction` controls which sign reads as "good":
//   higher_good (default) — up = green, down = red (e.g. revenue, conversions)
//   lower_good            — down = green, up = red (e.g. bounce rate, cost/booking)
//   neutral               — always gray (no good/bad connotation)
//
// Renders "—" (no pill) when value is null/undefined, so a metric with no prior
// period doesn't show a misleading 0%.
export const DeltaBadge = ({ value, direction = 'higher_good' }) => {
  if (value === null || value === undefined) {
    return <span className="text-[13px] text-gray-400 dark:text-gray-500 font-medium">—</span>;
  }
  const num = Number(value) || 0;
  const isPositive = num > 0;
  const isNegative = num < 0;
  let colorClass;
  if (direction === 'neutral') {
    colorClass = 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400';
  } else if (direction === 'lower_good') {
    colorClass = isNegative
      ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400'
      : isPositive
      ? 'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-400'
      : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400';
  } else {
    colorClass = isPositive
      ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400'
      : isNegative
      ? 'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-400'
      : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400';
  }
  const Arrow = isPositive ? (
    <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
    </svg>
  ) : isNegative ? (
    <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  ) : null;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[13px] font-semibold ${colorClass}`}>
      {Arrow}
      {num >= 0 ? '+' : ''}{num.toFixed(1)}%
    </span>
  );
};

export default DeltaBadge;
